import HistorySlider from './history-slider';

export default class HistorySliderDesktop extends HistorySlider {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/history-slider/history-slider.desktop.js